import PageRender from '@/models/PageRender';
import { Component } from 'vue-property-decorator';

@Component
export default class EcosystemPeopleComponent extends PageRender {
    public async mounted() {
        this.isLoading = false;
    }
}
